import React, { useState } from "react";
import { Link } from "react-router-dom";
import icon1 from "../../images/icon/sms-white.svg";
import icon2 from "../../images/icon/call-white.svg";
import icon3 from "../../images/icon/location.svg";
import icon4 from "../../images/icon/sms02.svg";
import Services from "../../api/service";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Footer = (props) => {
  const [email, setEmail] = useState("");

  const SubmitHandler = (e) => {
    e.preventDefault();

    if (!email || !email.trim()) {
      alert("Por favor, digite um email válido.");
      return;
    }

    // Validação básica de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      alert("Por favor, digite um email válido.");
      return;
    }

    const whatsappMessage = `📧 *NOVO LEAD - NEWSLETTER*

📧 *Email:* ${email.trim()}

Interessado em receber mais informações sobre as soluções da Somar Cloud.

---
_Lead capturado através da newsletter do site_`;

    const encodedMessage = encodeURIComponent(whatsappMessage);
    const whatsappUrl = `https://wa.me/551130901260?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");

    // Limpar o campo de email após envio
    setEmail("");
  };
  return (
    <footer
      className="footer footer-style-two pt-200 bg_img pos-rel"
      style={{ backgroundColor: "#0c111d" }}
    >
      <div className="container">
        <div className="xb-footer pt-120">
          <div className="footer-info ul_li_between">
            <div className="info-item ul_li">
              <div className="xb-item--icon">
                <span>
                  <img src={icon1} alt="" />
                </span>
              </div>
              <div className="xb-item--holder">
                <p className="xb-item--content">Email</p>
                <h4 className="xb-item--title">contato@somar.cloud</h4>
              </div>
            </div>
            <div className="info-item ul_li">
              <div className="xb-item--icon clr-blue">
                <span>
                  <img src={icon2} alt="" />
                </span>
              </div>
              <div className="xb-item--holder">
                <p className="xb-item--content">Whats App</p>
                <h4 className="xb-item--title">(11) 3090-1260</h4>
              </div>
            </div>
            <div className="info-item ul_li">
              <div className="xb-item--icon clr-sky">
                <span>
                  <img src={icon3} alt="" />
                </span>
              </div>
              <div className="xb-item--holder">
                <p className="xb-item--content">Endereço</p>
                <h4 className="xb-item--title">
                  Av. Paulista, 1106, Sala 01, Andar 16
                </h4>
              </div>
            </div>
          </div>
          <div className="footer-inner mt-70 mb-100 ul_li_between align-items-start">
            <div className="sa-newslatter footer-widget">
              <span className="xb-item--sub-title">
                Promoções e avisos importantes
              </span>
              <p className="xb-item--content clr-white">
                Fique por dentro de todas as nossas ofertas especiais!
              </p>
              <form
                className="xb-item--input_field pos-rel"
                onSubmit={SubmitHandler}
              >
                <input
                  type="email"
                  name="gmail"
                  id="text6"
                  placeholder="Digite seu email aqui"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <div className="img">
                  <img src={icon4} alt="" />
                </div>
                <button type="submit" className="xb-item--btn">
                  <i className="fas fa-paper-plane"></i>
                </button>
              </form>
              <span className="xb-item--text">
                Ao concordar você está de acordo com os{" "}
                <Link onClick={ClickHandler} to="/terms-conditions">
                  Termos de Uso
                </Link>{" "}
                e com nossa{" "}
                <Link onClick={ClickHandler} to="/privacy-policy">
                  Política de Privacidade
                </Link>
              </span>
            </div>
            <div className="footer-widget">
              <span className="xb-item--sub-title">A Empresa</span>
              <ul className="xb-item--holder list-unstyled">
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/about">
                    Sobre Nós
                  </Link>
                </li>
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/service">
                    Soluções
                  </Link>
                </li>
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/casestudy">
                    Projetos Entregues
                  </Link>
                </li>
              </ul>
            </div>
            <div className="footer-widget">
              <span className="xb-item--sub-title">Nossas Soluções</span>
              <ul className="xb-item--holder list-unstyled">
                {Services.slice(0, 6).map((service, srv) => (
                  <li key={srv} className="xb-item--list">
                    {service.title ? (
                      <Link
                        onClick={ClickHandler}
                        to={`/service-single/${service.slug}`}
                      >
                        <span className="icon_list_text">{service.title}</span>
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="footer-copyright mt-70 ul_li_between">
            <p className="copyright mt-20">
              Copyright © 2025{" "}
              <Link onClick={ClickHandler} to="/">
                Somar Cloud
              </Link>
              . Todos os direitos reservados.
            </p>
            <ul className="footer-link ul_li mt-20">
              <li>
                <span>Nos Acompanhe nas Redes Sociais:</span>
              </li>
              <li>
                <Link onClick={ClickHandler} to="/">
                  <i className="fab fa-facebook-f"></i>
                </Link>
              </li>
              <li>
                <Link onClick={ClickHandler} to="/">
                  <i className="fab fa-linkedin-in"></i>
                </Link>
              </li>
              <li>
                <Link onClick={ClickHandler} to="/">
                  <i className="fab fa-youtube"></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
